<template>
  <div>
    <v-card>
      <v-toolbar color="accent" :dark="dark">
        <v-toolbar-side-icon>
          <v-icon>mdi-account</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click.stop="dialog = true">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list two-line>
        <v-subheader v-if="value.length == 0">Ingen personer er lagt til</v-subheader>
        <template v-for="(item, index) in value">
          <v-subheader v-if="item.header" :key="item.header"></v-subheader>
          <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>
          <v-list-tile v-else :key="item.title" avatar>
            <v-list-tile-avatar @click="editUser(index)">
              <v-icon class="info white--text">mdi-account-edit</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-if="item.companyName">{{item.companyName}} <i>(bedrift)</i></v-list-tile-title>
              <v-list-tile-title v-else>{{item.firstname}} {{item.lastname}}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span class="text--primary">{{item.email}}</span>
                {{item.phone}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon ripple v-on:click="removePerson(index)">
                <v-icon color="grey lighten-1">mdi-account-remove</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card>
    <v-card-text style="height: 10px; position: relative" @click="addUser" v-if="value.length < max">
      <v-btn absolute dark fab top right small color="green">
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
    </v-card-text>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text v-html="dialogText">{{dialogText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <person-editor v-if="editDialog" :user="currentUser" @close-dialog="closePersonEditor" @person-saved="personSaved"></person-editor> 

    <v-snackbar v-model="snackbar" :multi-line="true">
      {{snackbarText}}
      <v-btn color="pink" flat @click="snackbar = false">Lukk</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import PersonEditor from './PersonEditor';
import Participant from '../../models/participant'
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    dialogText: {
      type: String,
      required: false
    },
    max: {
      type: Number,
      required: false,
      default: 10
    }
  },
  components: { PersonEditor },
  data() {
    return {
      date: "",
      windowWidth: window.innerWidth,
      dialog: false,
      tab: null,
      menu2: false,
      editDialog: false,
      snackbar: false,
      snackbarText: "",
      currentUser: new Participant()
    };
  },
  mounted () {
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowWidth = window.innerWidth
        });
      })
    },
  methods: {
    removePerson: function(index) {
      this.value.splice(index, 1);
      this.$emit("update-list");
      this.$emit("person-removed");
    },
    addUser: function() {
      this.currentUser = new Participant()
      this.editDialog = true;
    },
    editUser: function(index) {
      this.currentUser = this.value[index];
      this.currentUser.editing = true;
      this.currentUser.index = index
      this.editDialog = true;
    },
    closePersonEditor() {
      this.editDialog = false
    },
    personSaved(participant) {
      this.currentUser = participant
      if(participant.editing) {
        this.value[participant.index] = participant
      }
      else {
        this.value.push(this.currentUser);
        this.$emit("person-added");
      }
      this.closePersonEditor()
      this.$emit("update-list");
    }
  },
  computed: {
    dark: {
      get() {
        if (this.$store.state.protocol.dark) {
          return this.$store.state.protocol.dark;
        }
        return false;
      }
    }
  }
};
</script>